/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  $('.well').bind('closed', function() {
    return $.ajax({
      url: '/ajax/remove_info_text/' + $(this).data('id'),
      type: 'delete',
      dataType: 'script'
    });
  });

  $('.alert').bind('closed', function() {
    if ($(this).data('id')) {
      return $.ajax({
        url: '/ajax/remove_info_text/' + $(this).data('id'),
        type: 'delete',
        dataType: 'script'
      });
    }
  });

  return $( "input:submit, a.buttonStyleLink" ).button();
});

let eventsInfiniteScrollPending = false;
let eventsInfiniteScrollScheduled = false;
const eventsInfiniteScrollFrame = window.requestAnimationFrame || function(callback) {
  window.setTimeout(callback, 16);
};

function hasEventsInfiniteScroll() {
  return document.querySelector('[data-behavior="events-pagination"]');
}

function maybeLoadMoreEvents() {
  const button = document.querySelector('[data-behavior="events-load-more"]');

  if (!button) {
    return;
  }

  if (eventsInfiniteScrollPending || button.dataset.infiniteScrollDisabled === 'true') {
    return;
  }

  if (button.getBoundingClientRect().top <= window.innerHeight + 300) {
    eventsInfiniteScrollPending = true;
    button.click();
  }
}

function scheduleLoadMoreEvents() {
  if (!hasEventsInfiniteScroll() || eventsInfiniteScrollScheduled) {
    return;
  }

  eventsInfiniteScrollScheduled = true;

  eventsInfiniteScrollFrame(function() {
    eventsInfiniteScrollScheduled = false;
    maybeLoadMoreEvents();
  });
}

$(document).on('ajax:beforeSend', '[data-behavior="events-load-more"]', function() {
  const $button = $(this);

  eventsInfiniteScrollPending = true;

  $button
    .addClass('disabled')
    .attr('aria-busy', 'true')
    .attr('aria-disabled', 'true');

  $button.siblings('[data-behavior="events-load-more-spinner"]').removeClass('hide');
  $button.addClass('hide');
});

$(document).on('ajax:error', '[data-behavior="events-load-more"]', function() {
  const $button = $(this);

  eventsInfiniteScrollPending = false;

  $button
    .removeClass('disabled')
    .removeAttr('aria-busy')
    .removeAttr('aria-disabled');

  $button.attr('data-infinite-scroll-disabled', 'true');
  $button.removeClass('hide');
  $button.siblings('[data-behavior="events-load-more-spinner"]').addClass('hide');
});

$(document).on('events:content-loaded', function() {
  eventsInfiniteScrollPending = false;
  scheduleLoadMoreEvents();
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById('desc-container');
  const toggle = document.getElementById('desc-toggle');

  if (hasEventsInfiniteScroll()) {
    window.addEventListener('scroll', scheduleLoadMoreEvents, {passive: true});
    window.addEventListener('resize', scheduleLoadMoreEvents);
    scheduleLoadMoreEvents();
  }

  if (container && toggle) {
    const showMoreText = toggle.dataset.showMore || toggle.textContent;
    const showLessText = toggle.dataset.showLess || toggle.textContent;

    toggle.textContent = showMoreText;

    toggle.addEventListener('click', function () {
      const expanded = container.classList.toggle('expanded');
      toggle.textContent = expanded ? showLessText : showMoreText;
      toggle.setAttribute('aria-expanded', expanded);
    });
  }
});
